/* EuroVan – livraison : fiche produit (3 lignes), panier latéral, pastille du bandeau. 27/09/2026 (Isma)
   Réglages dans window.EVS_SHIP.cfg (snippets/evs-ship-core.liquid) :
   cutoff 16 h Paris · prep 1 jour ouvré d'expédition · transit tmin–tmax jours ouvrés · thr = seuil livraison offerte (devise active)
   zones = tarifs « dès » du profil d'expédition (en centimes, devise de la zone). */
(function () {
  var S = window.EVS_SHIP;
  if (!S || S._on) return;
  S._on = 1;
  var C = S.cfg, T = S.t, lang = C.lang || 'en';
  /* 01/10/2026 (Isma) : délai total 2–4 jours ouvrés en France, 3–5 jours ouvrés ailleurs (comme au paiement) */
  if (C.country && C.country !== 'FR' && !C._tx) { C.tmin += 1; C.tmax += 1; C._tx = 1; }
  var rate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
  var THR = C.thr > 0 ? C.thr : Math.ceil(39900 * rate * 1.03);
  var ss = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- montants ---------- */
  /* 05/10/2026 (Isma) : même format que snippets/evs-fmt.liquid (langue + devise) : « 579 € », « €579 » (en), « 2 588 zł », « 224 700 Ft », centimes seulement s'il y en a */
  var NB = '\u202f', LG = String(lang).toLowerCase().split('-')[0];
  var SUF = { EUR: '€', PLN: 'zł', CZK: 'Kč', HUF: 'Ft', RON: 'lei', DKK: 'kr.', NOK: 'kr', SEK: 'kr', ISK: 'kr', RSD: 'RSD' };
  function money(c, cur) {
    cur = cur || C.cur;
    c = Math.round(c);
    var whole = c % 100 === 0, n = Math.floor(c / 100), sep;
    if (LG === 'en') sep = ',';
    else if (['fr', 'pl', 'cs', 'hu', 'no', 'nb', 'nn', 'pt', 'sv', 'fi', 'sk'].indexOf(LG) > -1) sep = NB;
    else sep = '.';
    if (n < 10000 && (LG === 'es' || LG === 'pl')) sep = '';
    var out = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (whole ? '' : (LG === 'en' ? '.' : ',') + ('0' + (c % 100)).slice(-2));
    if (cur === 'EUR' && LG === 'en') return '€' + out;
    if (cur === 'GBP') return '£' + out;
    if (cur === 'CHF') return 'CHF' + NB + out;
    if (SUF[cur]) return out + NB + SUF[cur];
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  /* 27/09/2026 : montants calculés (frais, reste à payer, mensualités) arrondis à l'unité supérieure au-delà de 29 */
  function rnd(c) { return c > 2900 ? Math.ceil(c / 100) * 100 : c; }
  function zoneOf(cc) { if (C.zones[cc]) return C.zones[cc]; if (C.eu.indexOf(cc) > -1) return C.zones.EU; return zoneCur(); }
  /* 04/10/2026 (Isma) : pays sans grille (hors zones) : tarif de la zone de la devise affichée, jamais « calculé au paiement » */
  function zoneCur() { var m = { EUR: 'EU', GBP: 'GB', CHF: 'CH', PLN: 'PL', CZK: 'CZ', DKK: 'DK', HUF: 'HU', NOK: 'NO', RON: 'RO', SEK: 'SE', ISK: 'IS', RSD: 'RS' }; return C.zones[m[C.cur] || 'EU'] || C.zones.EU; }
  /* « dès X » dans la devise affichée : un tarif en EUR est converti au taux Shopify si la boutique affiche une autre devise */
  function feeC(z, cents) {   /* tarif dans la devise du panier (centimes), null si non convertible */
    cents = cents == null ? z.f : cents;
    if (z.c === C.cur) return cents;
    if (z.c === 'EUR') return rnd(Math.round(cents * rate));
    return null;
  }
  function zoneFee(z, cents) { var c = feeC(z, cents); return c == null ? money(cents == null ? z.f : cents, z.c) : money(c); }
  /* adresse de livraison mémorisée (fiche produit et panier partagent la même) */
  var DNEN0 = null; try { DNEN0 = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) {}
  function addr() {
    var a = ss.get('evs_addr'); if (a) return a;
    var o = ss.get('evs_ship') || {}, c = ss.get('evs_caddr') || {};
    return { cc: o.cc || (c.country && /^[A-Z]{2}$/.test(c.country) ? c.country : null), zip: o.zip || c.zip || '', calc: !!o.calc };
  }
  function setAddr(cc, zip) { ss.set('evs_addr', { cc: cc, zip: zip || '', calc: true }); }
  /* panier (pour la fiche produit : livraison offerte si panier + article >= seuil) */
  var C0 = C.cart || {}, CART = { total: +C0.t || 0, count: +C0.n || 0, w: +C0.w || 0, v: C0.v || [], ok: !!C.cart }, cartCbs = [], cartT = null;
  function loadCart() {
    clearTimeout(cartT);
    cartT = setTimeout(function () {
      fetch((C.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
        if (!c) return; CART = { total: c.total_price || 0, count: c.item_count || 0, w: c.total_weight || 0, v: (c.items || []).map(function (i) { return i.variant_id; }), ok: true };
        /* 06/10/2026 (Isma) : livraison offerte seulement avec le code FREE-SHIP-399 appliqué au panier */
        /* 07/10/2026 (Isma) : livraison offerte AUTOMATIQUE dès le seuil (remise automatique Shopify) — le code FREE-SHIP-399 reste accepté */
        window.__evsFsOn = (c.total_price || 0) >= THR || (c.discount_codes || []).some(function (d) { return String(d.code || '').toUpperCase() === 'FREE-SHIP-399' && d.applicable !== false; });
        try { document.dispatchEvent(new CustomEvent('evs:fs')); } catch (x) {}
        topbar(c); cartCbs.forEach(function (f) { f(); });
      }).catch(function () {});
    }, 250);
  }
  /* tranche de poids du profil d'expédition : < 7 kg, 7–12 kg, ≥ 12 kg */
  function tier(z, grams) { var t = z.t || [z.f]; return t[Math.min(t.length - 1, grams < 7000 ? 0 : grams < 12000 ? 1 : 2)]; }
  var DN = null; try { DN = new Intl.DisplayNames([lang], { type: 'region' }); } catch (e) {}
  function cname(cc) { try { return DN ? DN.of(cc) : cc; } catch (e) { return cc; } }
  /* pays proposés dans les calculateurs = pays des zones d'expédition (France, UE + Norvège, Suisse, Royaume-Uni) */
  var ALW = null;
  function allowed() {
    if (!ALW) ALW = Object.keys(C.zones).filter(function (k) { return k !== 'EU'; }).concat(C.eu).sort(function (a, b) { return cname(a).localeCompare(cname(b), lang); });
    return ALW;
  }
  function fillSel(sel, cc) {
    var L = allowed(), h = L.map(function (k) { return '<option value="' + k + '">' + esc(cname(k)) + '</option>'; }).join('');
    if (sel.innerHTML !== h) sel.innerHTML = h;
    sel.value = L.indexOf(cc) > -1 ? cc : (L.indexOf(C.country) > -1 ? C.country : L[0]);
    var lb = sel.closest('label'); if (lb) { lb.hidden = L.length < 2; if (lb.parentNode) lb.parentNode.classList.toggle('is-one', L.length < 2); }
  }
  /* code postal par défaut (l'adresse IP ne donne que le pays ; les tarifs EuroVan ne dépendent que du pays et du poids) */
  var DZ = { FR: '75001', DE: '10115', NL: '1011 AA', BE: '1000', LU: '1111', AT: '1010', ES: '28001', IT: '00118', PT: '1100-148', PL: '00-001', CZ: '110 00', SK: '811 01', HU: '1051', RO: '010011', BG: '1000', GR: '105 57', HR: '10000', SI: '1000', DK: '1050', SE: '111 20', FI: '00100', NO: '0150', EE: '10111', LV: 'LV-1050', LT: '01100', CY: '1010', MT: 'VLT 1010', IE: '', CH: '8001', GB: 'SW1A 1AA', MC: '98000' };

  /* ---------- dates (heure de Paris, jours ouvrés lun–ven) ---------- */
  function paris() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' })); }
  function work(d) { var x = d.getDay(); return x > 0 && x < 6; }
  function addWork(d, n) { d = new Date(d); var k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (work(d)) k++; } return d; }
  function nextWork(d) { d = new Date(d); while (!work(d)) d.setDate(d.getDate() + 1); return d; }
  /* jour de prise en compte : aujourd'hui si jour ouvré avant 16 h, sinon le jour ouvré suivant */
  function base(now) { var b = new Date(now.getFullYear(), now.getMonth(), now.getDate()); if (!work(b) || now.getHours() >= C.cutoff) b = addWork(b, 1); return b; }
  function range(now) { var b = base(now), ship = addWork(b, C.prep); return { ship: ship, d1: addWork(ship, C.tmin), d2: addWork(ship, C.tmax), b: b }; }
  function fd(d) { try { return new Intl.DateTimeFormat(/^en/i.test(lang) ? 'en-GB' : lang, { day: 'numeric', month: 'short' }).format(d); } catch (e) { return d.toLocaleDateString(); } }
  function fr(r) { return fd(r.d1) + ' – ' + fd(r.d2); }
  S.range = range; S.fmtRange = fr;

  var EST = { en: 'Estimated delivery {D}', fr: 'Livraison estimée {D}', de: 'Voraussichtliche Lieferung {D}', nl: 'Verwachte levering {D}', es: 'Entrega estimada {D}', it: 'Consegna stimata {D}', pt: 'Entrega estimada {D}', pl: 'Przewidywana dostawa {D}', cs: 'Předpokládané doručení {D}', hu: 'Várható kézbesítés: {D}', ro: 'Livrare estimată {D}', hr: 'Procijenjena dostava {D}', el: 'Εκτιμώμενη παράδοση {D}', da: 'Forventet levering {D}', no: 'Forventet levering {D}', nb: 'Forventet levering {D}' };
  /* 14/10/2026 (Isma) : ligne compacte « date de livraison + frais » juste sous la
     disponibilité et AVANT le bouton d'ajout au panier. L'information vient du même
     calcul que le bloc de livraison ; les deux lignes devenues doubles sont masquées
     dans le bloc sous le bouton, pour ne jamais dire deux fois la même chose. */
  function miniCss() {
    if (document.getElementById('evs-dl-mini-css')) return;
    var s = document.createElement('style'); s.id = 'evs-dl-mini-css';
    s.textContent = [
      '.evs-dl-mini{display:flex;align-items:center;flex-wrap:wrap;gap:2px 12px;margin:0 0 10px;font-size:13.5px;line-height:1.3;color:#1B313F}',
      '.evs-dl-mini[hidden]{display:none}',
      '.evs-dl-mini>svg{flex:0 0 auto;color:#2E4A5C}',
      '.evs-dl-mini b,.evs-dl-mini strong{font-weight:700}',
      '.evs-dl-mini s{opacity:.55;font-weight:400}',
      '.evs-dl-mini .is-free{color:#1F8A4C}',
      '.evs-dl-mini__s{opacity:.4}',
      '.evs-dl-mini__n{color:#5A6B75;font-size:12.5px;font-weight:400}',
      '.evs-dl-mini__dot{width:8px;height:8px;border-radius:50%;display:inline-block;background:#1F8A4C;margin-right:2px}',
      '.evs-dl-mini__dot.is-low{background:#EA7D27}',
      '.evs-sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}',
      '.evs-dl.evs-mini-on .evs-dl__l2{display:none!important}',
      '.evs-dl.evs-mini-on .evs-dl__l1 .evs-dl__main{display:none!important}',
      '.evs-dl.evs-mini-on.evs-mini-nosub .evs-dl__l1{display:none!important}',
      '.evs-dl.evs-mini-empty{display:none!important}',
      '.evs-dl-mini__n.is-urgent{color:#C2410C;font-weight:600}',
      '.evs-dl-mini.evs-dl-mini--in{margin:12px 0 0;justify-content:flex-start}',
      /* 14/10/2026 (Isma) : espacements homogènes (12 px) entre les blocs de la zone d'achat — le sélecteur de taille portait 30 px de marge basse */
      'html body .product-info .product-options variant-picker .option-selector:last-of-type{margin-bottom:0!important}',
      'html body .product-info .product-options .evs-cards{margin-bottom:0!important}',
      /* 14/10/2026 (Isma) : carte d'achat — hiérarchie et rythme vertical (16 / 12 / 8 px) */
      '.evs-dl-mini.evs-dl-mini--in{display:flex;flex-direction:column;align-items:stretch;gap:8px;font-size:14px;line-height:1.35;color:#1B313F}',
      '.evs-mr{display:grid;grid-template-columns:20px 1fr;column-gap:10px;align-items:start}',
      '.evs-mr__i{display:flex;justify-content:center;align-items:center;height:19px;color:#2E4A5C}',
      '.evs-mr__i .evs-dl-mini__dot{margin:0}',
      '.evs-mr__t strong,.evs-mr__t b{font-weight:700}',
      '.evs-mr__n{display:block;margin-top:2px;font-size:12.5px;color:#5A6B75;font-weight:400}',
      '.evs-mr__n b{font-weight:600;color:#1B313F}',
      '.evs-mr__n.is-urgent,.evs-mr__n.is-urgent b{color:#C2410C}',
      '.evs-mr__m{font-size:12.5px;color:#5A6B75;font-weight:400}',
      '.evs-mr__t .is-free{color:#1F8A4C}',
      'html body .product-info .evs-bb-top{padding:16px 16px 0!important}',
      'html body .product-info .evs-bb-bot{padding:0 16px 16px!important}',
      'html body .product-info .evs-bb-bot .evs-bb-usp{margin-top:16px!important;padding-top:16px!important;border-top:1px solid #E6ECEF!important}',
      'html body .product-info .evs-bb-bot .evs-bb-usp li span{color:#4A5E6A;font-size:11px;line-height:1.3}',
      'html body .product-info .evs-bb-bot .evs-bb-pay{margin-top:14px!important}',
      /* frigos : seules les cartes à icônes de charnières restent ; pas de doublon texte ni de texte d'aide */
      'html body .product-info .option-selector.evs-hh-on .evs-cards{display:none!important}',
      'html body .product-info .evs-hinge-help{display:none!important}',
      /* 14/10/2026 (Isma) : bloc de livraison compact, et dont les espacements tiennent
         qu'il soit sous ou au-dessus du bouton d'ajout au panier (test A/B à venir). */
      '.evs-dl.evs-dl--cmp{margin:10px 0 0!important;padding:10px 0 0!important}',
      '.evs-dl.evs-dl--cmp:last-child{margin-bottom:0!important}',
      '.evs-dl.evs-dl--cmp .evs-dl__row{padding:2px 0!important}',
      '.evs-dl.evs-dl--above{margin:4px 0 12px!important;padding:10px 0 0!important}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ================= FICHE PRODUIT ================= */
  function initPdp(box) {
    if (box._on) return; box._on = 1;
    /* 02/10/2026 (Isma) : 3 lignes avec icônes — ● état du stock / 🚚 livraison estimée + « commandez dans … » / 📦 frais (selon le pays) · gratuité ; retours retirés */
    (function () {
      var l1 = box.querySelector('[data-l1]'), l3 = box.querySelector('[data-l3-t]');
      if (l1) { var ic = l1.querySelector('svg'), t = document.createElement('span');
        t.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 9.38a1 1 0 0 0-.78-.38H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
        if (ic) ic.parentNode.replaceChild(t.firstChild, ic); else l1.insertBefore(t.firstChild, l1.firstChild); }
      if (l3) { var p3 = l3.closest('p') || l3.parentNode; if (p3) p3.setAttribute('data-l3row', ''); }
      box.classList.add('evs-3r');
    })();
    var inv = []; try { inv = JSON.parse(box.querySelector('[data-inv]').textContent); } catch (e) {}
    var q = function (s) { return box.querySelector(s); };
    var stock = q('[data-stock]'), l1 = q('[data-l1]'), l1t = q('[data-l1-t]'), l2 = q('[data-l2]'), l2v = q('[data-l2-v]');
    var est = q('[data-l2-est]'), edit = q('[data-l2-edit]'), form = q('[data-form]'), sel = q('[data-cc]'), zip = q('[data-zip]'), sub = q('[data-sub]');
    var st = addr(), cur = null, l2c = q('[data-l2-cc]');
    q('[data-l2-lbl]').textContent = T.ship;
    est.textContent = T.calc + ' ›'; edit.setAttribute('aria-label', T.edit); edit.title = T.edit;
    q('[data-lbl-cc]').textContent = T.country; q('[data-lbl-zip]').textContent = T.zip; q('[data-calc]').textContent = T.calc;
    q('[data-l3-t]').textContent = T.ret;
    /* 29/09/2026 (Isma) : lien « Voir les conditions » retiré après « Retours 30 jours » */
    (function(){var b=q('[data-l3-b]');if(!b)return;var p=b.previousSibling;if(p&&p.nodeType===3&&/·/.test(p.nodeValue))p.parentNode.removeChild(p);b.style.display='none';})();
    /* pays : celui déjà choisi, sinon celui du visiteur */
    var cc0 = st.cc || C.country;
    fillSel(sel, cc0);
    if (st.zip) zip.value = st.zip;

    function variant() {
      var f = document.querySelector('.js-product-form-main') || document.querySelector('form[action*="/cart/add"]');
      var id = f && f.querySelector('[name="id"]'), v = null;
      for (var i = 0; i < inv.length; i++) if (id && String(inv[i].id) === String(id.value)) v = inv[i];
      return v || inv[0];
    }
    function qty() { var i = document.querySelector('.js-product-form-main [name="quantity"]'); return Math.max(1, parseInt(i ? i.value : 1, 10) || 1); }
    function state(v) {
      if (!v.a) return 'oos';
      if (v.m && v.q <= 0 && v.p === 'continue') return 'back';
      if (v.m && v.q > 0 && v.q <= 5) return 'low';
      return 'in';
    }
    function line1(v, s) {
      var now = paris();
      l1.classList.remove('is-urgent');
      if (s === 'in' || s === 'low') {
        var r = range(now), dl = new Date(r.b); dl.setHours(C.cutoff, 0, 0, 0);
        var ms = dl - now, h = Math.floor(ms / 3600000), m = Math.floor(ms % 3600000 / 60000);
        if (ms > 0 && ms <= 86400000) {
          var t = h ? T.hm.replace('{h}', h).replace('{m}', m < 10 ? '0' + m : m) : T.m.replace('{m}', m);
          if (box.classList.contains('evs-3r')) {
            var om = (T.cd || '').match(/\(([^)]*\{T\}[^)]*)\)/), ord = om ? om[1] : '{T}'; ord = ord.charAt(0).toUpperCase() + ord.slice(1);
            l1t.innerHTML = '<span class="evs-dl__main">' + esc(EST[(lang || 'en').slice(0, 2)] || EST.en).replace('{D}', '<strong>' + esc(fr(r)) + '</strong>') + '</span><span class="evs-dl__subt">' + esc(ord).replace('{T}', '<strong>' + esc(t) + '</strong>') + '</span>';
          } else
          l1t.innerHTML = esc(T.cd).replace('{T}', '<strong>' + esc(t) + '</strong>').replace('{D}', '<strong>' + esc(fr(r)) + '</strong>');
          if (ms < 7200000) l1.classList.add('is-urgent');
        } else {
          l1t.innerHTML = box.classList.contains('evs-3r') ? '<span class="evs-dl__main">' + esc(EST[(lang || 'en').slice(0, 2)] || EST.en).replace('{D}', '<strong>' + esc(fr(r)) + '</strong>') + '</span>' : esc(T.dl).replace('{D}', '<strong>' + esc(fr(r)) + '</strong>');
        }
        l1.hidden = false; return;
      }
      if (s === 'back' && v.rd) {
        var p = v.rd.split('-'), sh = new Date(+p[0], +p[1] - 1, +p[2]), today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        if (sh >= today) {
          sh = nextWork(sh);
          var rr = { d1: addWork(sh, C.tmin), d2: addWork(sh, C.tmax) };
          l1t.innerHTML = esc(T.pre).replace('{S}', '<strong>' + esc(fd(sh)) + '</strong>').replace('{D}', '<strong>' + esc(fr(rr)) + '</strong>');
          l1.hidden = false; return;
        }
      }
      l1.hidden = true;
    }
    function line2(v, s) {
      /* 28/09/2026 (Isma) : une seule ligne « Frais de livraison : 9,99 € · offerte dès 399 € » (plus de calculateur ni de sous-ligne) */
      form.hidden = true; est.hidden = true; edit.hidden = true; sub.hidden = true; sub.innerHTML = '';
      if (s === 'oos') { l2.hidden = true; return; }
      l2.hidden = false;
      var A = addr(), cc = (A.calc && A.cc && allowed().indexOf(A.cc) > -1) ? A.cc : C.country, z = zoneOf(cc), n = qty(), inCart = CART.v.indexOf(+v.id) > -1;
      var tot = CART.total + (inCart ? 0 : v.pr * n), nofree = C.nofree.indexOf(cc) > -1, free = !nofree && tot >= THR;   /* 07/10/2026 : produit éligible = livraison affichée offerte */
      l2v.className = 'evs-dl__v'; l2c.textContent = ''; l2c.hidden = true;
      if (free) { l2v.textContent = T.free; l2v.classList.add('is-free'); return; }
      /* 07/10/2026 (Isma) : panier ≥ seuil mais code pas encore appliqué → frais barrés + OFFERTE + « avec le code dans le panier » (au lieu de « 19,99 € · offerte dès 399 € ») */
      if (z && !nofree && THR && tot >= THR) {
        l2v.innerHTML = '<s class="evs-dl__was">' + esc(zoneFee(z, tier(z, inCart ? (CART.w || 0) : (v.w || 0) * n))) + '</s> <span class="is-free">' + esc(T.free) + '</span>';
        if (T.fcode) { l2c.textContent = T.fcode; l2c.hidden = false; }
        return;
      }
      if (z) {
        l2v.textContent = zoneFee(z, tier(z, inCart ? (CART.w || 0) : (v.w || 0) * n));
        if (!nofree && THR) { l2c.textContent = T.ffl.replace('{X}', money(THR)); l2c.hidden = false; }
      } else l2v.textContent = T.chk;
    }
    /* interrupteur du test A/B : classe evs-dl-above sur <html> ou window.EVS_DL_ABOVE = true,
       posés avant ou après le chargement — le bloc passe alors au-dessus du bouton et la ligne
       compacte s'efface, pour que l'information ne soit jamais écrite deux fois. */
    function dlAbove() {
      try { return document.documentElement.classList.contains('evs-dl-above') || !!window.EVS_DL_ABOVE; } catch (e) { return false; }
    }
    function placeDl() {
      miniCss();
      box.classList.add('evs-dl--cmp');
      var top = document.querySelector('.product-info .evs-bb-top');
      if (!top || !top.parentNode) return;
      var up = dlAbove();
      if (up) {
        if (box.parentNode !== top.parentNode || box.nextElementSibling !== top) top.parentNode.insertBefore(box, top);
        box.classList.add('evs-dl--above');
      } else if (box.classList.contains('evs-dl--above')) {
        box.classList.remove('evs-dl--above');
        var bot = document.querySelector('.product-info .evs-bb-bot');
        if (bot && box.parentNode !== bot) bot.insertBefore(box, bot.firstChild);
      }
      /* le thème impose la marge intérieure du bloc avec un !important porté par l'identifiant
         de section : seul un style en ligne la reprend. Sans cela, hors de la carte d'achat le
         bloc est décalé de 14 px vers la droite par rapport au reste de la colonne. */
      /* au-dessus du bouton le bloc est une carte bordee : il lui faut la meme marge
         interieure que la carte d'achat (14 px), sinon l'icone touche la bordure.
         Sous le bouton il n'a qu'un filet en haut : marge laterale nulle, mais une
         marge basse pour que l'icone ne colle pas au bord. */
      box.style.setProperty('padding', up ? '12px 14px' : '10px 0', 'important');
      box.style.setProperty('margin', up ? '4px 0 12px' : '10px 0 0', 'important');
    }
    var miniP = null;
    function miniEl() {
      if (miniP && miniP.parentNode) return miniP;
      /* une seule ligne compacte, même si la page porte deux blocs de livraison */
      var ex = document.querySelector('.product-info .evs-dl-mini');
      if (ex) { if (ex.__owner && ex.__owner !== box) return null; miniP = ex; ex.__owner = box; return ex; }
      var a = document.querySelector('.product-info .evs-bb-top');
      if (!a) { var btn = document.querySelector('.product-info [name="add"]'); a = btn && btn.closest ? btn.closest('.product-info__block') : null; }
      if (!a || !a.parentNode) return null;
      miniP = document.createElement('p'); miniP.className = 'evs-dl-mini'; miniP.__owner = box;
      /* 14/10/2026 (Isma, plus tard) : la ligne livraison passe SOUS le bouton d'ajout au panier, dans la carte d'achat */
      if (a.classList && a.classList.contains('evs-bb-top')) { miniP.classList.add('evs-dl-mini--in'); miniP.style.setProperty('margin', '14px 0 0', 'important'); a.appendChild(miniP); }
      else a.parentNode.insertBefore(miniP, a.nextSibling);
      return miniP;
    }
    function dspOff(el, off) { if (!el) return; if (off) el.style.setProperty('display', 'none', 'important'); else el.style.removeProperty('display'); }
    function mini(v, s) {
      miniCss();
      var el = miniEl(); if (!el) return;
      var mainSp = l1t.querySelector('.evs-dl__main'), subSp = l1t.querySelector('.evs-dl__subt');
      if (dlAbove()) {
        el.hidden = true; box.classList.remove('evs-mini-on', 'evs-mini-nosub', 'evs-mini-empty');
        dspOff(stock.closest ? stock.closest('.evs-dl__row') : null, false);
        dspOff(l2, false); dspOff(mainSp, false); dspOff(l1, false);
        return;
      }
      /* le thème pose un display:flex !important porté par l'identifiant de section sur les
         lignes du bloc : on masque donc en style en ligne, une feuille ne suffit pas. */
      if (s !== 'in' && s !== 'low') {
        el.hidden = true; box.classList.remove('evs-mini-on', 'evs-mini-nosub', 'evs-mini-empty');
        dspOff(stock.closest ? stock.closest('.evs-dl__row') : null, false);
        dspOff(l2, false); dspOff(mainSp, false); dspOff(l1, false);
        return;
      }
      var r = range(paris()), h = '', gotStock = false;
      /* la disponibilité est déjà affichée au-dessus par les pastilles de taille ; sinon on la reprend ici */
      /* 24/10/2026 (Isma) : la disponibilité est toujours affichée sous le bouton (plus de ligne « taille · stock » au-dessus) */
      if (true) {
        gotStock = true;
        h += '<span class="evs-dl-mini__dot' + (s === 'low' ? ' is-low' : '') + '" aria-hidden="true"></span><span>' + esc(stock.textContent || '') + '</span>';
      }
      if (gotStock) h += '<span class="evs-dl-mini__s" aria-hidden="true">·</span>';
      h += '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 9.38a1 1 0 0 0-.78-.38H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>' + '<span><span class="evs-sr">' + esc(String(EST[LG] || EST.en).replace('{D}', '').replace(/\s*:\s*$/, '').trim()) + ' </span><strong>' + esc(fr(r)) + '</strong></span>';
      /* 14/10/2026 (Isma) : « 16 oct. – 20 oct. (commandez dans les 4 h 54 min) · Livraison : … »
         — le compte a rebours rejoint la plage de dates sur la meme ligne ; la ligne
         autonome sous le bouton disparait (voir dspOff(l1, true) plus bas). */
      if (subSp) {
        var tv = subSp.querySelector('strong'), tvh = tv ? tv.innerHTML : '';
        var om2 = (T.cd || '').match(/\(([^)]*\{T\}[^)]*)\)/), ordr = om2 ? om2[1] : '{T}';
        if (tvh) h += ' <span class="evs-dl-mini__n' + (l1.classList.contains('is-urgent') ? ' is-urgent' : '') + '">(' + esc(ordr).replace('{T}', '<b>' + tvh + '</b>') + ')</span>';
      }
      if (!l2.hidden && l2v.innerHTML) {
        var fv = l2v.innerHTML, free = l2v.classList.contains('is-free');
        var lbl = String(T.ship || '').replace(/\s*[::]\s*$/, '');
        /* 14/10/2026 : plus de point separateur devant les frais — quand la ligne passe a deux
           lignes sur mobile, il se retrouvait seul en debut de ligne et se lisait comme une puce.
           C'est l'ecart horizontal (12 px) qui separe desormais les deux segments. */
        h += '<span>' + esc(lbl) + ' : <b' + (free ? ' class="is-free"' : '') + '>' + fv + '</b>';
        if (l2c && !l2c.hidden && l2c.textContent) h += ' <span class="evs-dl-mini__n">(' + esc(l2c.textContent) + ')</span>';
        h += '</span>';
      }
      /* 14/10/2026 (Isma) : sous le bouton, la livraison devient une liste lisible (colonne d'icônes alignées) :
         ● disponibilité / camion + dates en gras, compte à rebours en dessous / colis + frais, gratuité en gris */
      if (el.classList.contains('evs-dl-mini--in')) {
        var H = '', IC = 'viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
        if (gotStock) H += '<span class="evs-mr evs-mr--st"><span class="evs-mr__i"><span class="evs-dl-mini__dot' + (s === 'low' ? ' is-low' : '') + '"></span></span><span class="evs-mr__t">' + esc(stock.textContent || '') + '</span></span>';
        var cd = '';
        if (subSp) { var tv2 = subSp.querySelector('strong'), tvh2 = tv2 ? tv2.innerHTML : ''; var om3 = (T.cd || '').match(/\(([^)]*\{T\}[^)]*)\)/), o3 = om3 ? om3[1] : '{T}'; if (tvh2) cd = '<span class="evs-mr__n' + (l1.classList.contains('is-urgent') ? ' is-urgent' : '') + '">' + esc(o3.charAt(0).toUpperCase() + o3.slice(1)).replace('{T}', '<b>' + tvh2 + '</b>') + '</span>'; }
        H += '<span class="evs-mr"><span class="evs-mr__i"><svg ' + IC + '><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 9.38a1 1 0 0 0-.78-.38H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg></span><span class="evs-mr__t"><span class="evs-sr">' + esc(String(EST[LG] || EST.en).replace('{D}', '').replace(/\s*:\s*$/, '').trim()) + ' </span><strong>' + esc(fr(r)) + '</strong>' + cd + '</span></span>';
        if (!l2.hidden && l2v.innerHTML) {
          var fv2 = l2v.innerHTML, fr2 = l2v.classList.contains('is-free'), lb2 = String(T.ship || '').replace(/\s*[::]\s*$/, '');
          H += '<span class="evs-mr"><span class="evs-mr__i"><svg ' + IC + '><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg></span><span class="evs-mr__t">' + esc(lb2) + ' : <b' + (fr2 ? ' class="is-free"' : '') + '>' + fv2 + '</b>' + (l2c && !l2c.hidden && l2c.textContent ? ' <span class="evs-mr__m">· ' + esc(l2c.textContent.replace(/^\(|\)$/g, '')) + '</span>' : '') + '</span></span>';
        }
        h = H;
      }
      if (el.__h !== h) { el.innerHTML = h; el.__h = h; }
      el.hidden = false;
      box.classList.add('evs-mini-on');
      box.classList.toggle('evs-mini-nosub', !subSp);
      dspOff(l2, true); dspOff(mainSp, true); dspOff(l1, true);
      /* 14/10/2026 (Isma) : l'etat du stock est deja dans la ligne compacte — on ne l'ecrit pas deux fois. */
      dspOff(stock.closest ? stock.closest('.evs-dl__row') : null, gotStock);
      (function () {
        var vis = false, rows = box.querySelectorAll('.evs-dl__row');
        for (var i = 0; i < rows.length; i++) { if (!rows[i].hidden && getComputedStyle(rows[i]).display !== 'none') { vis = true; break; } }
        box.classList.toggle('evs-mini-empty', !vis);
      })();
    }
    function run() {
      var v = variant(); if (!v) return; cur = v;
      var s = state(v);
      box.dataset.state = s;
      stock.textContent = s === 'oos' ? T.oos : s === 'back' ? T.back : s === 'low' ? T.low.replace('{n}', v.q) : T.in;
      placeDl(); line1(v, s); line2(v, s); mini(v, s);
      box.hidden = false;
    }
    function calc(e) {
      if (e) e.preventDefault();
      setAddr(sel.value, zip.value.trim());
      form.hidden = true; run(); fillCart(document);
    }
    est.addEventListener('click', function () { form.hidden = !form.hidden; if (!form.hidden) zip.focus(); });
    edit.addEventListener('click', function () { form.hidden = false; zip.focus(); });
    q('[data-calc]').addEventListener('click', calc);
    zip.addEventListener('keydown', function (e) { if (e.key === 'Enter') calc(e); });
    cartCbs.push(function () { if (cur) run(); });
    /* conditions de retour */
    var dlg = q('[data-dlg]');
    q('[data-l3-b]') && q('[data-l3-b]').addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-dlg-x]')) dlg.close(); });
    q('[data-dlg-t]').textContent = T.rt; q('[data-dlg-x]').setAttribute('aria-label', T.close);
    q('[data-dlg-l]').innerHTML = [T.r1, T.r2, T.r3, T.r4].map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
    var full = q('[data-dlg-full]'); full.textContent = T.full;
    /* recalcul : taille, variante, quantité */
    var later = function () { setTimeout(run, 0); };
    document.addEventListener('change', later);
    document.addEventListener('on:variant:change', later);
    document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') later(); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('quantity-input button, .qty-input__btn, [name="minus"], [name="plus"]')) setTimeout(run, 60); });
    run(); setInterval(run, 60000);
  }

  /* ================= PANIER LATÉRAL ================= */
  var busyCart = false;
  function fillCart(root) {
    root.querySelectorAll('[data-evs-cdl]').forEach(function (el) {
      var d = el.querySelector('[data-d]'), v = el.querySelector('[data-v]'), form = (el.closest('[data-evs-cwrap]') || el.parentNode).querySelector('[data-evs-cform]');
      var lab = el.querySelector('[data-l]'); if (lab && lab.textContent !== T.lbl) lab.textContent = T.lbl;
      var dt = el.dataset.pre ? T.cpre : fr(range(paris()));
      if (d.textContent !== dt) d.textContent = dt;
      var sig = el.dataset.sig, base = +el.dataset.total || 0, st = ss.get('evs_cship'), ship = 0, html;
      var A = addr(), cc = (A.cc && allowed().indexOf(A.cc) > -1) ? A.cc : C.country, z = zoneOf(cc), zc = z ? feeC(z, tier(z, +el.dataset.w || 0)) : null;
      var ed = '', edOn = false, inDr = !!el.closest('#cart-drawer');
      /* 06/10/2026 (Isma) : bouton « Appliquer » de la livraison offerte = −montant de la livraison */
      var fee = zc != null ? money(zc) : (z ? zoneFee(z, tier(z, +el.dataset.w || 0)) : ''), fb = (el.closest('#cart-drawer, .shopify-section') || document).querySelector('[data-evs-eg][data-kind="fs"] .evs-eg__b b');
      if (fb && fee && fb.textContent !== '−' + fee) fb.textContent = '−' + fee;   /* 28/09/2026 : le crayon est placé à côté de « Livraison » (montants alignés à droite) */
      if (el.dataset.free || (el.dataset.fthr && window.__evsFsOn)) html = '<span class="is-free">' + esc(T.free) + '</span>';
      else if (zc != null) { ship = zc; html = '<span>' + esc(money(zc)) + '</span>'; edOn = true; }   /* immédiat : grille tarifaire du pays */
      else if (z) { html = '<span>' + esc(zoneFee(z, tier(z, +el.dataset.w || 0))) + '</span>'; edOn = true; }   /* pays facturé dans sa propre devise (ex. Suisse en CHF) */
      else if (st && st.sig === sig) { ship = st.cents; html = '<span>' + esc(money(st.cents)) + '</span>'; edOn = true; }
      else if (inDr) { html = '<span class="evs-cdl__chk">' + esc(T.chk) + '</span>'; autoRates(el); }   /* 03/10/2026 (Isma) : pas de calculateur dans le panier latéral */
      else { html = '<button type="button" class="evs-cdl__est" data-cest>' + esc(T.est) + '</button>'; autoRates(el); }
      if (v.innerHTML !== html) v.innerHTML = html;
      var eb = el.querySelector('[data-cedit]');
      if (!eb && lab) { lab.insertAdjacentHTML('afterend', '<button type="button" class="evs-cdl__ed" data-cedit aria-label="' + esc(T.edit) + '" title="' + esc(T.edit) + '">✎</button>'); eb = el.querySelector('[data-cedit]'); }
      if (inDr) edOn = false;   /* 03/10/2026 (Isma) : crayon (calculateur) retiré du panier latéral */
      if (eb && eb.hidden === edOn) eb.hidden = !edOn;
      /* Klarna : « ou 3/4 × X sans frais » sur le total livraison comprise */
      var kl = (el.closest('#cart-drawer, .shopify-section') || document).querySelector('[data-evs-kl]');
      if (kl) {
        var kn = +kl.dataset.kn || 0, kt = base + ship, kh = !(kn && kt >= 3500 && kt <= 200000);
        if (!kh) { var kx = esc(kl.dataset.t).replace('[n]', kn).replace('%X%', '<b>' + esc(money(rnd(Math.ceil(kt / kn)))) + '</b>'); if (kl.innerHTML !== kx) kl.innerHTML = kx; }
        if (kl.hidden !== kh) kl.hidden = kh;
      }
      /* total TTC et bouton « Passer commande » incluent la livraison estimée */
      var dr = el.closest('#cart-drawer') || document, tot = money(base + ship);
      var dd = dr.querySelector('.vpc-sum__sub dd'); if (dd && dd.textContent !== tot) dd.textContent = tot;
      var wa = dr.querySelector('.vpc-sum__was'); if (wa) { var ws = wa.querySelector('[data-was]'), wt = money(+wa.dataset.cmp + ship); if (ws && ws.textContent !== wt) ws.textContent = wt; }   /* 04/10/2026 : total barré livraison comprise */
      var bs = dr.querySelector('button[name="checkout"] span');
      if (bs) { var p = bs.textContent.split(' · ')[0]; if (bs.textContent !== p) bs.textContent = p; }   /* 03/10/2026 (Isma) : bouton sans montant */
      if (form && !form._on) initCartForm(form, el);
    });
    root.querySelectorAll('[data-evs-t]').forEach(function (e) { var x = T[e.dataset.evsT]; if (x && e.textContent !== x) e.textContent = x; });
    /* champ « Code promo » : masqué seulement quand une remise par code est affichée dans « Vous économisez » */
    root.querySelectorAll('[data-vpc-promo]').forEach(function (pm) {
      var sc = pm.closest('#cart-drawer, .shopify-section') || document;
      var h = pm.dataset.hide === '1' && !!sc.querySelector('.vpc-save');
      if (pm.hidden !== h) pm.hidden = h;
    });
    /* ligne de réassurance : toujours sur une seule ligne (police réduite si besoin, 11 px minimum) */
    root.querySelectorAll('.vpc-payline').forEach(function (p) {
      if (!p.offsetParent) return;
      var fs = parseFloat(p.dataset.fs || getComputedStyle(p).fontSize); p.dataset.fs = fs; p.style.fontSize = fs + 'px';
      var lh = function () { return parseFloat(getComputedStyle(p).fontSize) * 1.55; };
      while (p.getBoundingClientRect().height > lh() * 1.5 && fs > 11) { fs -= 0.5; p.style.fontSize = fs + 'px'; }
    });
  }
  /* tarif réel Shopify calculé d'office : pays du client (choisi, sinon celui de son IP) + code postal saisi ou par défaut */
  var tried = {};
  function rates(p) {
    var root = C.root || '/';
    return fetch(root + 'cart/prepare_shipping_rates.json?' + p, { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return pollR(root, p, 0); });
  }
  function pollR(root, p, n) {
    return fetch(root + 'cart/async_shipping_rates.json?' + p, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (r.status === 202 || r.status === 204) { if (n > 12) return []; return new Promise(function (res) { setTimeout(res, 500); }).then(function () { return pollR(root, p, n + 1); }); }
      return r.json().then(function (j) { return j.shipping_rates || []; });
    });
  }
  function lowest(list) { return list.reduce(function (a, r) { var c = Math.round(parseFloat(r.price) * 100); return c < a ? c : a; }, Infinity); }
  /* Shopify renvoie les tarifs dans la devise de la boutique (EUR) : si le panier est dans une autre devise (GBP, CHF…),
     on reprend le tarif de la zone du pays pour le poids réel du panier (les tarifs EuroVan ne dépendent que du pays et du poids) */
  var DNEN = null; try { DNEN = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) {}
  function iso(c) {
    if (/^[A-Z]{2}$/.test(c)) return c;
    var all = Object.keys(C.zones).concat(C.eu);
    for (var i = 0; i < all.length; i++) { try { if (DNEN && DNEN.of(all[i]) === c) return all[i]; } catch (e) {} }
    return c;
  }
  function inCur(list, cc) {
    if (!list[0].currency || list[0].currency === C.cur) return Promise.resolve(rnd(lowest(list)));
    return fetch((C.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var z = zoneOf(iso(cc));
      if (!z) return rnd(Math.round(lowest(list) * rate));
      var f = tier(z, c.total_weight || 0);
      return z.c === C.cur ? f : (z.c === 'EUR' ? rnd(Math.round(f * rate)) : f);
    });
  }
  function autoRates(el) {
    var sig = el.dataset.sig; if (tried[sig]) return; tried[sig] = 1;
    var a = addr(), cc = a.cc || C.country, zp = a.zip ? a.zip : (DZ[cc] != null ? DZ[cc] : '');
    var q = function (z) { return 'shipping_address[country]=' + encodeURIComponent(cc) + '&shipping_address[zip]=' + encodeURIComponent(z); };
    rates(q(zp)).catch(function () { return zp ? rates(q('')) : []; }).then(function (list) {
      if (!list || !list.length) return;
      return inCur(list, cc).then(function (cents) { ss.set('evs_cship', { sig: sig, cents: cents }); fillCart(document); });
    }).catch(function () {});
  }
  function initCartForm(form, el) {
    form._on = 1;
    form.querySelector('[data-lbl-cc]').textContent = T.country; form.querySelector('[data-lbl-zip]').textContent = T.zip;
    var btn = form.querySelector('[data-calc]'); btn.textContent = T.calc;
    var sel = form.querySelector('select'), zip = form.querySelector('input'), msg = form.querySelector('[data-msg]');
    var st = addr();
    fillSel(sel, st.cc || C.country);
    if (st.zip) zip.value = st.zip;
    function go(e) {
      if (e) e.preventDefault();
      if (btn.disabled) return;
      msg.hidden = true;
      /* pays avec grille connue : calcul immédiat, sans appel serveur */
      if (zoneOf(sel.value)) { setAddr(sel.value, zip.value.trim()); form.hidden = true; fillCart(document); cartCbs.forEach(function (f) { f(); }); return; }
      btn.disabled = true;
      var root = C.root || '/', p = 'shipping_address[country]=' + encodeURIComponent(sel.value) + '&shipping_address[zip]=' + encodeURIComponent(zip.value.trim());
      setAddr(iso(sel.value), zip.value.trim());
      rates(p)
        .then(function (list) {
          if (!list || !list.length) { msg.textContent = T.norate; msg.hidden = false; return; }
          return inCur(list, sel.value).then(function (min) {
            ss.set('evs_cship', { sig: el.dataset.sig, cents: min });
            form.hidden = true; fillCart(document); cartCbs.forEach(function (f) { f(); });
          });
        })
        .catch(function (j) {
          var t = T.err;
          if (j && typeof j === 'object') { var a = []; for (var k in j) a.push([].concat(j[k]).join(' ')); if (a.length) t = a.join(' '); }
          msg.textContent = t; msg.hidden = false;
        })
        .then(function () { btn.disabled = false; });
    }
    btn.addEventListener('click', go);
    zip.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(e); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cest],[data-cedit]');
    if (!b) return;
    e.preventDefault();
    var f = (b.closest('[data-evs-cwrap]') || document).querySelector('[data-evs-cform]');
    if (f) { f.hidden = b.hasAttribute('data-cedit') ? false : !f.hidden; if (!f.hidden) { var z = f.querySelector('input'); if (z) z.focus(); } }
  });

  /* ================= PASTILLE DU BANDEAU ================= */
  function topbar(c) {
    document.querySelectorAll('[data-evs-fs]').forEach(function (s) {
      var rte = s.querySelector('.rte') || s;
      if (rte.dataset.orig === undefined) rte.dataset.orig = rte.innerHTML;
      /* 28/09/2026 (Isma) : le bandeau ne suit plus le panier (« Plus que X / Livraison offerte » retiré) : texte d'origine toujours */
      if (true) { if (rte.innerHTML !== rte.dataset.orig) rte.innerHTML = rte.dataset.orig; return; }
      var left = THR - (c.total_price || 0);
      var txt = left > 0 ? T.left.replace('{X}', money(left)) : T.freeok;
      var h = '<p><strong>🚚 ' + esc(txt.toUpperCase()) + '</strong></p>';
      if (rte.innerHTML !== h) rte.innerHTML = h;
    });
  }
  /* ================= OUVERTURE IMMÉDIATE DU PANIER =================
     Au clic sur « Ajouter au panier », le panier s'ouvre tout de suite (chargement), puis son contenu s'affiche. */
  var addT = null;
  function adding(on) {
    var dr = document.getElementById('cart-drawer'); if (!dr) return;
    clearTimeout(addT);
    if (on) { dr.classList.add('evs-adding'); addT = setTimeout(function () { adding(false); }, 8000); }
    else dr.classList.remove('evs-adding');
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('js-product-form') || f.id === 'product-signup_form') return;
    /* 04/10/2026 (Isma) : aussi depuis l'ajout rapide : la fenêtre d'ajout rapide se ferme et le mini panier s'ouvre tout de suite */
    if (!(window.theme && theme.settings && theme.settings.afterAtc === 'drawer')) return;
    var b = f.querySelector('[name="add"]'); if (b && b.getAttribute('aria-disabled') === 'true') return;
    adding(true);
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
  }, true);
  document.addEventListener('on:cart:error', function () { adding(false); document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close', { bubbles: true })); });

  /* 04/10/2026 (Isma) : fenêtre d'ajout rapide : « Expédition calculée lors du passage en caisse » remplacé par un montant
     (« Frais de livraison : dès 9,99 € · offerte dès 399 € », ou « OFFERTE » si le panier dépasse déjà le seuil) */
  function qaShip() {
    document.querySelectorAll('quick-add-drawer .product-policies').forEach(function (el) {
      if (el.dataset.evsQa) return; el.dataset.evsQa = '1';
      var tax = (el.firstChild && el.firstChild.nodeType === 3) ? el.firstChild.textContent.trim() : '';
      var A = addr(), cc = (A.cc && allowed().indexOf(A.cc) > -1) ? A.cc : C.country, z = zoneOf(cc);
      var free = C.nofree.indexOf(cc) < 0 && THR && CART.total >= THR, h;
      if (free) h = esc(T.ship) + ' <b>' + esc(T.free) + '</b>';
      else h = esc(T.ship) + ' <b>' + esc(T.frm.replace('{X}', zoneFee(z, z.f))) + '</b>' + (THR ? ' · ' + esc(T.ffl.replace('{X}', money(THR))) : '');
      el.innerHTML = (tax ? esc(tax) + '<br>' : '') + h;
    });
  }
  (function () {
    var go = function () { try { qaShip(); } catch (e) {} };
    new MutationObserver(go).observe(document.body, { childList: true, subtree: true });
    go();
  })();

  /* ================= LISTE DÉROULANTE DES VARIANTES (thème natif) =================
     Ajoute à chaque ligne le prix et la disponibilité de la variante correspondante
     (autres options = celles déjà choisies) : En stock / Plus que N / Sur commande / Rupture. */
  var RS = { en: 'Back {d}', fr: 'Dispo le {d}', de: 'Ab {d}', nl: 'Vanaf {d}', es: 'Desde el {d}', it: 'Dal {d}', pt: 'A partir de {d}', pl: 'Od {d}', cs: 'Od {d}', hu: 'Érkezik: {d}', ro: 'Din {d}', hr: 'Od {d}', el: 'Από {d}', da: 'Fra {d}', no: 'Fra {d}', nb: 'Fra {d}' };
  function ddInit() {
    document.querySelectorAll('variant-picker').forEach(function (vp) {
      if (!vp.querySelector('.custom-select') || vp._evsdd) return; vp._evsdd = 1;
      var pj = null; try { pj = JSON.parse(vp.querySelector('script[type="application/json"]').textContent).product; } catch (e) {}
      if (!pj || !pj.variants) return;
      var inv = {}; try { JSON.parse(document.querySelector('[data-evs-dl] [data-inv]').textContent).forEach(function (x) { inv[x.id] = x; }); } catch (e) {}
      var sels = [].slice.call(vp.querySelectorAll('.custom-select'));
      function cur(i) { var b = sels[i].querySelector('.custom-select__option[aria-selected="true"]'); return b ? b.dataset.value : null; }
      function paint() {
        var chosen = sels.map(function (s, i) { return cur(i); });
        sels.forEach(function (sel, i) {
          sel.querySelectorAll('.custom-select__option').forEach(function (li) {
            var want = chosen.slice(); want[i] = li.dataset.value;
            var v = null; pj.variants.forEach(function (x) { if (!v && x.options.every(function (o, k) { return want[k] == null || o === want[k]; })) v = x; });
            var st, cls, pr = '', rdl = '';
            if (!v) { st = T.oos; cls = 'oos'; }
            else {
              var n = inv[v.id] || {}; pr = money(v.price);
              if (!v.available) { st = T.oos; cls = 'oos'; }
              else if (n.m && n.q <= 0 && n.p === 'continue') { st = T.back; cls = 'back'; }
              else if (n.m && n.q > 0 && n.q <= 5) { st = T.low.replace('{n}', n.q); cls = 'low'; }
              else { st = T.in; cls = 'in'; }
              /* 01/10/2026 (Isma) : date de retour en stock (metafield custom.restock_date) si rupture / sur commande */
              if ((cls === 'back' || cls === 'oos') && n.rd) {
                var rp = n.rd.split('-'), rdd = new Date(+rp[0], +rp[1] - 1, +rp[2]), td = new Date(); td.setHours(0, 0, 0, 0);
                if (rdd >= td) { rdl = (RS[(lang || 'en').slice(0, 2)] || RS.en).replace('{d}', fd(rdd)); st = rdl; cls += ' is-rd'; }
              }
            }
            /* 01/10/2026 (Isma) : ordre dimension · état de stock · prix · ancien prix (barré) */
            var cp = (v && cls !== 'oos' && v.compare_at_price > v.price) ? money(v.compare_at_price) : '';
            var h = '<span class="evs-dd__s is-' + cls + '">' + esc(st) + '</span>'
              + '<b class="evs-dd__p">' + (pr && cls !== 'oos' ? esc(pr) : '') + '</b>'
              + '<s class="evs-dd__c">' + esc(cp) + '</s>'
              + '<span class="evs-dd__b">' + (cp ? '−' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '\u00a0%' : '') + '</span>';
            var m = li.querySelector('.evs-dd'); if (!m) { m = document.createElement('span'); m.className = 'evs-dd pointer-events-none'; li.appendChild(m); li.classList.add('has-evs'); }
            if (m.innerHTML !== h) m.innerHTML = h;
          });
        });
      }
      paint();
      vp.addEventListener('change', function () { setTimeout(paint, 30); });
      vp.addEventListener('click', function () { setTimeout(paint, 30); });
      document.addEventListener('on:variant:change', function () { setTimeout(paint, 30); });
    });
  }

  /* lien « Contact » cliqué dans une fenêtre (guide d'achat, dimensions…) : la fenêtre se ferme pour laisser voir le formulaire de contact */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/pages/contact"], [data-evs-contact], [data-evs-cs="email"]');
    if (!a) return;
    var dl = a.closest('dialog[open]');
    if (dl) setTimeout(function () { try { dl.close(); } catch (x) { dl.removeAttribute('open'); } }, 0);
  }, true);


  /* 02/10/2026 (Isma) : sur mobile, le tableau « Spécifications » passe juste sous « Avantages du produit » (onglet fermé) */
  function specMobile() {
    /* 13/10/2026 (Isma, brouillon Vevor) : sur tous les écrans, la fiche technique rejoint « Informations complémentaires » (juste avant) */
    if (document.querySelector('.evs-spec-m')) return;
    var ul = document.querySelector('.product-details .product-spec'), adv = document.querySelector('.product-info details.disclosure--row');
    if (!ul || !adv) return;
    var sec = ul.closest('.shopify-section'), tab = sec && sec.querySelector('.tablist__tab');
    var d = adv.cloneNode(true); d.removeAttribute('open'); d.classList.remove('evs-pk'); d.classList.add('evs-spec-m');
    var h = d.querySelector('h2'), ic = h && h.querySelector('svg');
    if (h) { h.innerHTML = '<svg class="icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M8 6h13M8 12h13M8 18h13"/><circle cx="3.5" cy="6" r="1"/><circle cx="3.5" cy="12" r="1"/><circle cx="3.5" cy="18" r="1"/></svg> ' + esc((tab ? tab.textContent : 'Specifications').trim()); }
    var p = d.querySelector('.disclosure__panel'); if (!p) return;
    p.innerHTML = '<div class="disclosure__content"></div>'; p.firstChild.appendChild(ul);
    var dsc = null; document.querySelectorAll('.product-info details.disclosure--row').forEach(function (x) { if (!dsc && x !== d && x.querySelector('summary .icon--question_mark')) dsc = x; });
    /* 14/10/2026 (Isma) : « Informations complémentaires » passe AVANT la fiche technique */
    if (dsc) dsc.parentNode.insertBefore(d, dsc.nextSibling); else adv.parentNode.insertBefore(d, adv.nextSibling);
    if (sec && sec.querySelectorAll('.tablist__tab').length <= 1) sec.style.display = 'none';
    dlBloc();
  }

  /* 14/10/2026 (Isma) : les téléchargements sortent de « Informations complémentaires »
     et deviennent un accordéon à part entière, placé juste après la fiche technique.
     Le titre est repris tel quel de la section de la description, donc il est déjà
     traduit dans les 15 langues : aucune fiche ni traduction à retoucher.
     Une fiche sans section Téléchargements n'a pas d'accordéon vide. */
  function dlBloc() {
    if (document.querySelector('.evs-dl-m')) return;
    var it = document.querySelector('.product-info .evs-dsec__item--dl');
    if (!it) return;
    var body = it.querySelector('.evs-dsec__body'), ttl = it.querySelector('.evs-dsec__title');
    if (!body || body.innerHTML.trim() === '') return;
    var model = document.querySelector('.product-info details.disclosure--row');
    if (!model) return;
    var d = model.cloneNode(true);
    d.removeAttribute('open'); d.classList.remove('evs-pk', 'evs-spec-m'); d.classList.add('evs-dl-m');
    var h = d.querySelector('h2');
    if (h) { h.innerHTML = '<svg class="icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/><path d="M12 15V3"/></svg> ' + esc((ttl ? ttl.textContent : 'Downloads').trim()); }
    var p = d.querySelector('.disclosure__panel'); if (!p) return;
    p.innerHTML = '<div class="disclosure__content rte"></div>';
    p.firstChild.innerHTML = body.innerHTML;
    var spec = document.querySelector('.product-info .evs-spec-m');
    var dsc = null; document.querySelectorAll('.product-info details.disclosure--row').forEach(function (x) { if (!dsc && x !== d && x.querySelector('summary .icon--question_mark')) dsc = x; });
    var anchor = spec || dsc;
    if (anchor) anchor.parentNode.insertBefore(d, anchor.nextSibling); else return;
    it.parentNode.removeChild(it);
  }
  /* 14/10/2026 (Isma) : accordéon « Avis clients » dans la colonne d'achat, replié, avec la
     note et le nombre d'avis visibles dans le titre (format repéré chez Jacksons Leisure).
     Il ne contient qu'un résumé — note, 2 avis les plus récents, lien vers les avis complets ;
     le widget Judge.me reste en pleine largeur en bas de page, donc un seul widget sur la page.
     Les deux libellés sont traduits ici dans les 15 langues : aucune fiche à retoucher. */
  var RVT = { en: 'Customer reviews', fr: 'Avis clients', de: 'Kundenbewertungen', nl: 'Klantbeoordelingen', da: 'Kundeanmeldelser', no: 'Kundeanmeldelser', nb: 'Kundeanmeldelser', es: 'Opiniones de clientes', it: 'Recensioni dei clienti', pt: 'Avaliações de clientes', ro: 'Recenzii ale clienților', pl: 'Opinie klientów', cs: 'Zákaznické recenze', hr: 'Recenzije kupaca', el: 'Κριτικές πελατών', hu: 'Vásárlói vélemények' };
  var RVA = { en: 'Read all {N} reviews', fr: 'Lire les {N} avis', de: 'Alle {N} Bewertungen lesen', nl: 'Alle {N} beoordelingen lezen', da: 'Læs alle {N} anmeldelser', no: 'Les alle {N} anmeldelser', nb: 'Les alle {N} anmeldelser', es: 'Leer las {N} opiniones', it: 'Leggi tutte le {N} recensioni', pt: 'Ler as {N} avaliações', ro: 'Citește toate cele {N} recenzii', pl: 'Przeczytaj wszystkie opinie ({N})', cs: 'Přečíst všech {N} recenzí', hr: 'Pročitaj sve recenzije ({N})', el: 'Διαβάστε όλες τις {N} κριτικές', hu: 'Mind a {N} vélemény' };
  function revCss() {
    if (document.getElementById('evs-rev-css')) return;
    var s = document.createElement('style'); s.id = 'evs-rev-css';
    s.textContent = [
      '.evs-rev-m .evs-rev__hd{display:inline-flex;align-items:center;gap:5px;font-size:13.5px;font-weight:600;white-space:nowrap}',
      '.evs-rev__stars{display:inline-flex;align-items:center;gap:1px;line-height:0}',
      '.evs-rev__s{fill:#D7DCDF}.evs-rev__s.is-on{fill:#E0A21B}',
      '.evs-rev-m .evs-rev__hd em{font-style:normal;color:#5A6B75;font-weight:400}',
      '.evs-rev__l{list-style:none;margin:0;padding:0}',
      '.evs-rev__it{padding:10px 0;border-top:1px solid #E6ECEF}',
      '.evs-rev__it:first-child{border-top:0;padding-top:2px}',
      '.evs-rev__m{margin:4px 0 2px;font-size:13.5px;line-height:1.45}',
      '.evs-rev__m strong{font-weight:700}',
      '.evs-rev__w{margin:0;font-size:12.5px;color:#5A6B75}',
      '.evs-rev__all{display:inline-block;margin-top:10px;font-size:13.5px;font-weight:600;text-decoration:underline;text-underline-offset:3px;background:none;border:0;padding:0;color:inherit;cursor:pointer;font-family:inherit}'
    ].join('');
    document.head.appendChild(s);
  }
  function revTxt(e) { return e ? (e.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  /* étoiles dessinées ici : celles de Judge.me sont une police chargée dans son propre widget
     et ne s'affichent pas si on recopie son balisage ailleurs dans la page. */
  function revStars(score, px) {
    var n = Math.round(score || 0), h = '<span class="evs-rev__stars" aria-hidden="true">', i;
    px = px || 13;
    for (i = 1; i <= 5; i++) h += '<svg class="evs-rev__s' + (i <= n ? ' is-on' : '') + '" width="' + px + '" height="' + px + '" viewBox="0 0 24 24"><path d="M12 2.6l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.5 6.1 20.6l1.2-6.5L2.5 9.5l6.6-.9z"/></svg>';
    return h + '</span>';
  }
  function revScore(rv) {
    var r = rv.querySelector('.jdgm-rev__rating'), a = r ? (r.getAttribute('aria-label') || '') : '';
    var m = a.match(/(\d(?:[.,]\d)?)/);
    if (m) return parseFloat(m[1].replace(',', '.'));
    /* repli : Judge.me traduit l'étiquette et peut l'omettre — on compte les étoiles allumées */
    return r ? r.querySelectorAll('.jdgm-star.jdgm--on').length : 0;
  }
  function revWidget() {
    var w = null;
    document.querySelectorAll('.jdgm-review-widget').forEach(function (x) { if (!w && x.querySelector('.jdgm-rev')) w = x; });
    return w;
  }
  function revBloc() {
    if (document.querySelector('.evs-rev-m')) return;
    var w = revWidget(); if (!w) return;
    /* 14/10/2026 (Isma) : seuls les avis positifs (4 et 5 étoiles) sont repris dans le résumé.
       Les avis restent tous visibles, sans filtre, dans le widget complet en bas de page. */
    var all = [].slice.call(w.querySelectorAll('.jdgm-rev'));
    var revs = all.filter(function (x) { return revScore(x) >= 4; }).slice(0, 2);
    var badge0 = document.querySelector('.jdgm-prev-badge');
    var n0 = badge0 ? parseInt(badge0.getAttribute('data-number-of-reviews') || '0', 10) : 0;
    /* aucun avis positif sur la première page : on garde la note et le lien, sans extrait */
    if (!revs.length && n0 < 1) return;
    var model = document.querySelector('.product-info details.disclosure--row'); if (!model) return;
    var rows = document.querySelectorAll('.product-info details.disclosure--row');
    var last = rows[rows.length - 1]; if (!last || !last.parentNode) return;
    revCss();
    var badge = document.querySelector('.jdgm-prev-badge');
    var n = badge ? parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10) : 0;
    var avg = badge ? parseFloat(badge.getAttribute('data-average-rating') || '0') : 0;
    var starsEl = badge ? badge.querySelector('.jdgm-prev-badge__stars') : null;
    var label = RVT[LG] || RVT.en;
    var d = model.cloneNode(true);
    d.removeAttribute('open'); d.classList.remove('evs-pk', 'evs-spec-m', 'evs-dl-m'); d.classList.add('evs-rev-m');
    var h = d.querySelector('h2');
    if (h) {
      var hd = '';
      if (n > 0) {
        var av = '';
        try { av = avg.toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); } catch (e) { av = String(avg); }
        hd = '<span class="evs-rev__hd">' + revStars(avg, 14) + (avg > 0 ? '<b>' + esc(av) + '</b>' : '') + '<em>(' + n + ')</em></span>';
      }
      h.innerHTML = '<svg class="icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.8-5.2 2.8 1-5.8L3.6 9.7l5.8-.8z"/></svg> ' + esc(label) + ' ' + hd;
    }
    var p = d.querySelector('.disclosure__panel'); if (!p) return;
    var items = revs.map(function (rv) {
      var au = revTxt(rv.querySelector('.jdgm-rev__author')), ts = revTxt(rv.querySelector('.jdgm-rev__timestamp'));
      var ti = revTxt(rv.querySelector('.jdgm-rev__title')), bo = revTxt(rv.querySelector('.jdgm-rev__body'));
      /* Judge.me reprend souvent les premiers mots de l'avis comme titre : on ne l'écrit pas deux fois */
      if (ti && bo && bo.toLowerCase().indexOf(ti.toLowerCase()) === 0) ti = '';
      if (!bo && ti) { bo = ti; ti = ''; }
      if (bo.length > 170) bo = bo.slice(0, 170).replace(/\s+\S*$/, '') + '…';
      return '<li class="evs-rev__it">' + revStars(revScore(rv), 12) +
        '<p class="evs-rev__m">' + (ti ? '<strong>' + esc(ti) + '</strong> ' : '') + esc(bo) + '</p>' +
        '<p class="evs-rev__w">' + esc(au) + (ts ? ' · ' + esc(ts) : '') + '</p></li>';
    }).join('');
    var lnk = (RVA[LG] || RVA.en).replace('{N}', n || revs.length);
    p.innerHTML = '<div class="disclosure__content">' + (items ? '<ul class="evs-rev__l">' + items + '</ul>' : '') + '<button type="button" class="evs-rev__all" data-evs-rev-all>' + esc(lnk) + ' ›</button></div>';
    var btn = p.querySelector('[data-evs-rev-all]');
    if (btn) btn.addEventListener('click', function () {
      var t = revWidget(); if (!t) return;
      var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
    last.parentNode.insertBefore(d, last.nextSibling);
  }

  function start() {
    ddInit();
    setTimeout(specMobile, 400);
    /* 14/10/2026 (Isma) : l'accordeon « Avis clients » est retire — le widget complet
       est juste en dessous sur la page et disait deux fois la meme chose.
       revBloc() est conserve pour pouvoir revenir en arriere. */
    /* (function rv(k) { revBloc(); if (k < 24 && !document.querySelector('.evs-rev-m')) setTimeout(function () { rv(k + 1); }, 500); })(0); */
    document.querySelectorAll('[data-evs-dl]').forEach(initPdp);
    var dr = document.getElementById('cart-drawer');
    fillCart(document);
    if (dr) {
      new MutationObserver(function () { if (busyCart) return; busyCart = true; requestAnimationFrame(function () { fillCart(dr); setTimeout(function () { busyCart = false; }, 30); }); }).observe(dr, { childList: true, subtree: true });
      /* contenu du panier remplacé par le thème (enfants directs) = ajout terminé */
      new MutationObserver(function () { if (dr.classList.contains('evs-adding')) adding(false); }).observe(dr, { childList: true });
    }
    document.addEventListener('evs:fs', function () { fillCart(document); });
    loadCart();
    ['on:cart:add', 'on:line-item:change', 'on:cart:change', 'on:cart-drawer:after-open', 'dispatch:cart-drawer:refresh'].forEach(function (ev) { document.addEventListener(ev, loadCart); });
    setInterval(function () { fillCart(document); }, 60000);
    /* scripts du panier mis en cache pendant que le visiteur lit la page */
    window.addEventListener('load', function () {
      setTimeout(function () {
        var sc = window.theme && theme.scripts; if (!sc || !sc.cartItems) return;
        [sc.cartItems].forEach(function (u) { if (document.querySelector('script[src="' + u + '"],link[href="' + u + '"]')) return; var l = document.createElement('link'); l.rel = 'prefetch'; l.as = 'script'; l.href = u; document.head.appendChild(l); });
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
